import { Color, Spacing } from '@persona-id/design-tokens';
import { COLORS, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import Button from 'design-system/components/Button';

export const ACTION_FOOTER_HEIGHT = '88px';

const ActionFooter = styled('div')`
  display: flex;
  justify-content: space-evenly;

  padding: ${SPACINGS.base * 2}px;

  position: fixed;
  bottom: 0px;

  // TODO (melissa): figure out shared constant for this
  width: 400px;
  height: ${ACTION_FOOTER_HEIGHT};

  box-shadow: 0 2px 5px 0 ${COLORS.gray20};
  background: ${Color.PrimaryWhite};
`;
const UndoButton = styled(Button)`
  margin-right: ${Spacing[4]};
`;

interface ThemeEditorFormActionFooterProps {
  dataTestBlock: string;
  submitting: boolean;
  pristine: boolean;
  handleUndo: () => void;
}

export default ({
  dataTestBlock,
  submitting,
  pristine,
  handleUndo,
}: ThemeEditorFormActionFooterProps) => {
  return (
    <ActionFooter>
      <UndoButton
        type='button'
        variant='basic'
        id={`${dataTestBlock}__undo`}
        data-test={`${dataTestBlock}__undo`}
        disabled={submitting || pristine}
        onClick={handleUndo}
      >
        Undo all
      </UndoButton>
      <Button
        type='submit'
        data-test={`${dataTestBlock}__save`}
        disabled={submitting || pristine}
        isPending={submitting}
      >
        Save
      </Button>
    </ActionFooter>
  );
};
